/* Copyright (C) 2019 SmartboxTV Spa - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import PropTypes from 'prop-types';

const getDisplayName = (WrappedComponent, defaultName = 'Unknown') => {
    return WrappedComponent.displayName || WrappedComponent.name || defaultName;
};

/**
 * @param  {React.Component} Child - The React.Component to enhance
 * @return {React.Component} - A react component that pass the component registry as prop to the Child
 */
const isField = Child => {
    class IsField extends React.Component {
        static contextTypes = {
            onFieldChange: PropTypes.func,
            validations: PropTypes.object,
        };

        constructor(props) {
            super(props);
            this.state = {
                value: this.props.value,
            };
        }

        static displayName = `IsField(${getDisplayName(Child, 'IsFieldChild')})`;

        UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps.value !== this.props.value && nextProps.name) {
                this.setState(
                    { value: nextProps.value },
                    this.context.onFieldChange(null, {
                        name: nextProps.name,
                        value: nextProps.value,
                    })
                );
            }
        }

        onChange = (e, t) => {
            const { value } = t;
            this.setState({ value }, () => {
                this.context.onFieldChange(e, t);
                if (this.props.onChange) this.props.onChange(e, t);
            });
        };

        /*Set a ref the children instead the wrapper*/
        setRef = childRef => {
            this.childRef = childRef;
            if (this.props.fieldRef) this.props.fieldRef(childRef);
        };

        render() {
            const { value } = this.state;
            return (
                <Child
                    {...this.props}
                    value={value}
                    validations={this.props.validations || this.context.validations}
                    onChange={this.onChange}
                    ref={this.setRef}
                />
            );
        }
    }

    return IsField;
};

export default isField;
